import { ConversationParticipantEntity } from '@provision/conversation-types';
import { useEffect } from 'react';
import { Conversation } from 'src/graphql';
import { useChatInputStore } from 'src/store/chat-input';

// An unresolved requester carries a stand-in name that is not worth showing on the strip.
function getStripRequesterFirstName(
  requester: Conversation['requesterData'] | undefined,
): string | undefined {
  if (!requester || requester.participantEntity === ConversationParticipantEntity.Unknown) {
    return undefined;
  }
  return requester.firstName || undefined;
}

/**
 * The requester re-resolves on every conversation switch (the joined client arrives a beat
 * after the record); the strip shows the last name it saw for this conversation meanwhile.
 */
export function useStripRequesterFirstName(
  conversation: Pick<Conversation, 'conversationId' | 'requesterData'>,
): string | undefined {
  const stripRequesterFirstNames = useChatInputStore.use.stripRequesterFirstNames();
  const rememberStripRequesterFirstName =
    useChatInputStore.use.rememberStripRequesterFirstName();
  const resolvedFirstName = getStripRequesterFirstName(conversation.requesterData);

  useEffect(() => {
    if (resolvedFirstName) {
      rememberStripRequesterFirstName(conversation.conversationId, resolvedFirstName);
    }
  }, [conversation.conversationId, resolvedFirstName, rememberStripRequesterFirstName]);

  return resolvedFirstName ?? stripRequesterFirstNames[conversation.conversationId];
}
